export const PALETTE = {
    primary: '#242424',
    secondary: '#383838',
    accent: '#1DB5B6',
    accentEn: '#3A68E2',
    accentLight: '#ECFFFE',
    accentLightEn: '#E7EFFF',
    accentDark: '#13ABAC',
    accentSecondary: '#9440FF',
    success: '#00B86B',
    error: '#F44336',
    warning: '#FE974A',
    warningDark: '#FF8800',
    neutral: '#899696',
    neutralEn: '#758282',
    neutralDark: '#616E6E',
    neutralMuted: '#A3A3A3',
    borderLight: '#F3F3F4',
    colorWhite: '#FFFFFF',
    telegram: '#229ED9',
    chartAmber: '#E0A100',
} as const;
